import styled, { css } from 'styled-components';

export const StyledGlobalWrapper = styled.div`${
  (props) => {
    const { styles } = props;
    const {
      color,
      inputsLabelsTextAlign,
      inputsBorderRadius,
      buttonsBorderRadius,
    } = styles.body || {};
    const {
      padding: containerPadding,
      margin: containerMargin,
      widgetContainerBorderRadius,
    } = styles.container || {};

    return css`
      input, select, textarea {
        border-radius: ${inputsBorderRadius}px !important;
      }
      
      button {
        border-radius: ${buttonsBorderRadius}px !important;
      }

      .styled-select {
        .bta-react-select__control {
          border-radius: ${inputsBorderRadius}px;
        }
        span[class$="indicatorSeparator"] {
          background-color: ${color};
        }
        svg[class$="Svg"] {
          color: ${color};
        }
      }
      .locations-select, .resources-select, .variant-select {
        .titles {
          display: inline-block;
          width: 100%;
          text-align: ${inputsLabelsTextAlign};
        }
      }  
      .sub-panel {
        border-radius: ${widgetContainerBorderRadius}px;
        padding: ${containerPadding}px;
        margin: ${containerMargin}px;  
      }
    `;
  }
}`;
